import { render, staticRenderFns } from "./SignupAfterConfirm.vue?vue&type=template&id=0b36c767&scoped=true"
import script from "./SignupAfterConfirm.vue?vue&type=script&lang=ts"
export * from "./SignupAfterConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SignupAfterConfirm.vue?vue&type=style&index=0&id=0b36c767&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36c767",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b36c767')) {
      api.createRecord('0b36c767', component.options)
    } else {
      api.reload('0b36c767', component.options)
    }
    module.hot.accept("./SignupAfterConfirm.vue?vue&type=template&id=0b36c767&scoped=true", function () {
      api.rerender('0b36c767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/SignupAfterConfirm.vue"
export default component.exports